import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { getThemeHelpers } from '../themes/themeRegistry.js';
import { resolveAppTheme } from '../themes/resolveAppTheme.js';
import { clearBodyTheme, syncBodyTheme } from '../themes/syncBodyTheme.js';

/**
 * Resolved theme for the current route (read-only).
 */
export function useAppTheme() {
  const location = useLocation();

  return useMemo(
    () => resolveAppTheme(location.pathname, location.state),
    [location.pathname, location.state]
  );
}

/**
 * Helpers derived from a resolved theme definition.
 *
 * @param {import('../themes/themeRegistry.js').ThemeDefinition} theme
 */
export function useThemeHelpers(theme) {
  return useMemo(() => getThemeHelpers(theme), [theme]);
}

/**
 * Apply `document.body` theme classes for the current route. Use once in App shell.
 */
export function useBodyThemeSync() {
  const theme = useAppTheme();

  useEffect(() => {
    syncBodyTheme(theme);

    return () => {
      clearBodyTheme();
    };
  }, [theme]);
}
